export default "/_next/static/images/optimizely-b159c1d9e24d649da5b4362e9113cf72.png";